module.exports = __webpack_public_path__ + "img/コンピュータのしくみII_1_9_1.f8d6d466.jpeg";